import { StrictMode } from "react";import { createRoot } from "react-dom/client";import App from "./App";import { configurePwaThemeAssets } from "./lib/pwa";import { initKitsosCdn } from "./lib/cdn";import "./styles/app.css";import "./styles/demo-shell.css";
configurePwaThemeAssets();
void initKitsosCdn();
createRoot(document.getElementById("root")!).render(<StrictMode><App/></StrictMode>);
